import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const LogResultModal = ({ onClose, onCreated }) => {
  const { authFetch } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    race_name: '',
    distance: '5k',
    race_date: '',
    finish_time: '',
    position: '',
    notes: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await authFetch('/api/races/results', {
        method: 'POST',
        body: JSON.stringify({
          ...formData,
          position: formData.position ? parseInt(formData.position) : null
        })
      });

      if (res.ok) {
        onCreated();
      } else {
        const data = await res.json();
        setError(data.detail || 'Failed to log race result');
      }
    } catch (err) {
      setError('Failed to log race result');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Log Race Result</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="modal-error">{error}</div>}

          <div className="form-group">
            <label>Race Name</label>
            <input
              type="text"
              name="race_name"
              value={formData.race_name}
              onChange={handleChange}
              placeholder="e.g., parkrun Finsbury Park"
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Distance</label>
              <select
                name="distance"
                value={formData.distance}
                onChange={handleChange}
              >
                <option value="5k">5K</option>
                <option value="10k">10K</option>
                <option value="half_marathon">Half Marathon</option>
                <option value="marathon">Marathon</option>
                <option value="ultra">Ultra</option>
              </select>
            </div>

            <div className="form-group">
              <label>Race Date</label>
              <input
                type="date"
                name="race_date"
                value={formData.race_date}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Finish Time</label>
              <input
                type="text"
                name="finish_time"
                value={formData.finish_time}
                onChange={handleChange}
                placeholder="e.g., 22:30 or 3:45:00"
                required
              />
            </div>

            <div className="form-group">
              <label>Position (optional)</label>
              <input
                type="number"
                name="position"
                value={formData.position}
                onChange={handleChange}
                placeholder="Overall position"
                min="1"
              />
            </div>
          </div>

          <div className="form-group">
            <label>Notes (optional)</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Weather, how you felt, etc."
              rows={2}
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Logging...' : 'Log Result'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LogResultModal;
